import { type ReactNode } from 'react';
import { getSdkInfoByKey } from '@gonfalon/sdk-info/sdkInfo';
import { Link, Text } from '@launchpad-ui/components';

import { trackSdkSetupSnippetClicked } from '../../../analytics';
import { SdkSetupSnippet } from '../../SdkSetupSnippet/SdkSetupSnippet';

import styles from './Installation.module.css';

export const ReactNativeInstallation = (
  selectedPackageManager: string,
  onPackageManagerChange: (pm: string) => void,
): ReactNode => {
  const { installSnippets } = getSdkInfoByKey('react-native-client-sdk');
  const asyncStorage = installSnippets?.asyncStorage;

  if (!asyncStorage || typeof asyncStorage !== 'object') {
    return null;
  }

  const reactNativeSnippets = [
    { title: 'yarn', snippet: asyncStorage.yarn ?? '', language: 'bash' },
    { title: 'npm', snippet: asyncStorage.npm ?? '', language: 'bash' },
    { title: 'pnpm', snippet: asyncStorage.pnpm ?? '', language: 'bash' },
  ];

  return (
    <>
      <Text className={styles.reactNativeText}>
        LaunchDarkly's React Native SDK v10 uses{' '}
        <Link
          href="https://github.com/react-native-async-storage/async-storage"
          target="_blank"
          rel="noopener noreferrer"
        >
          @react-native-async-storage/async-storage
        </Link>{' '}
        for bootstrapping. If you are <b>not using Expo</b>, you must explicitly add it as a dependency.
      </Text>
      <SdkSetupSnippet
        withCopyButton
        withCommandLine
        trackAnalyticsOnClick={() => trackSdkSetupSnippetClicked('react-native-client-async-storage')}
        selectedSnippetTitle={selectedPackageManager}
        onSelectedSnippetTitleChange={onPackageManagerChange}
        snippets={reactNativeSnippets}
      />
    </>
  );
};
